var map = {
	"./CATO_MasterLogo_2020.png": 328,
	"./VivaHolidays_Vertical_White_Logo_2019_h60px.png": 241,
	"./atas-logo-backup.png": 609,
	"./atas-logo.png": 243,
	"./go_holidays_logo.png": 610,
	"./go_holidays_logo_.png": 611,
	"./hlologo.svg": 244,
	"./holiday_here_logo.png": 612,
	"./nin.png": 329,
	"./payment-options.gif": 245,
	"./sunlover.png": 330,
	"./taanz.png": 246,
	"./taanzlogo.png": 613,
	"./td.png": 331,
	"./viva_vertical_logo.png": 326
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 608;